/**
 * SOLFIE — Swipe to Confirm.
 *
 * Marcação esperada (snippets/solfie-swipe.liquid):
 *   <div class="solfie-swipe" data-solfie-swipe data-href="/cart" data-done="Abrindo…">
 *     <span class="solfie-swipe__fill"></span>
 *     <span class="solfie-swipe__label">Deslize para finalizar</span>
 *     <span class="solfie-swipe__knob">…</span>
 *   </div>
 *
 * Comportamento: pressiona (escala/sombra) → arrasta (o círculo segue o dedo e a
 * barra preenche) → ao passar de 90% do percurso confirma (check + navegação).
 * Soltar antes de 90% volta para o começo. Teclado: setas andam, Enter/Espaço
 * confirmam (com animação), Esc/Home reinicia.
 *
 * Sem JS o snippet mostra um <noscript> com link comum — nada fica travado.
 */
(function () {
  'use strict';

  var THRESHOLD = 0.9;

  function init(root) {
    if (!root || root.dataset.spReady === '1') return;

    /* produto esgotado: sem gesto (o rótulo já diz "Esgotado"). Não marca
       como pronto: quando voltar ao estoque, iniciar() liga o gesto. */
    if (root.getAttribute('aria-disabled') === 'true') return;

    root.dataset.spReady = '1';

    var knob = root.querySelector('.solfie-swipe__knob');
    var label = root.querySelector('.solfie-swipe__label');
    if (!knob || !label) return;

    var labelInicial = root.dataset.label || label.textContent;
    var labelFeito = root.dataset.done || '';
    var p = 0;
    var max = 1;
    var arrastando = false;
    var confirmado = false;
    var inicioX = 0;
    var inicioP = 0;
    var pointerId = null;

    function medir() {
      /* escondido (drawer fechado) nao tem largura: nao grava 1px, senao o
         circulo nunca sai do lugar quando o drawer abre */
      var largura = root.clientWidth || root.getBoundingClientRect().width || 0;
      if (!largura) return;
      var style = window.getComputedStyle(root);
      var pad = parseFloat(style.paddingLeft) || 5;
      max = Math.max(1, largura - knob.offsetWidth - pad * 2);
      root.style.setProperty('--sp-max', max + 'px');
    }

    function definir(v, animar) {
      p = Math.min(1, Math.max(0, v));
      root.style.setProperty('--sp', p.toFixed(4));
      root.setAttribute('aria-valuenow', String(Math.round(p * 100)));
      if (animar === false) root.classList.add('is-dragging');
      else root.classList.remove('is-dragging');
    }

    function reiniciar() {
      arrastando = false;
      pointerId = null;
      root.classList.remove('is-pressed', 'is-dragging');
      definir(0);
    }

    function confirmar() {
      if (confirmado) return;
      confirmado = true;
      arrastando = false;
      pointerId = null;
      root.classList.remove('is-pressed', 'is-dragging');
      root.classList.add('is-done', 'is-blocked');
      definir(1);
      if (labelFeito) label.textContent = labelFeito;
      root.setAttribute('aria-valuenow', '100');

      var loaderSel = root.dataset.loader;
      if (loaderSel) {
        var loader = document.querySelector(loaderSel);
        if (loader) loader.style.display = 'block';
      }

      root.dispatchEvent(new CustomEvent('solfie:swipe-confirm', { bubbles: true }));

      var acao = root.dataset.swipeAction;
      var alvoForm = root.dataset.swipeForm;
      var href = root.dataset.href;
      var esperar = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 120 : 420;

      /* action: submit -> envia um form da página (add ao carrinho, etc.) */
      if (acao === 'submit' && alvoForm) {
        window.setTimeout(function () {
          var form = document.querySelector(alvoForm);
          if (!form) return;
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        }, esperar);
        return;
      }

      window.setTimeout(function () {
        if (href) window.location.href = href;
      }, esperar);
    }

    /* volta ao estado inicial (ex.: falha ao adicionar, ou item já no carrinho) */
    function reativar() {
      confirmado = false;
      arrastando = false;
      pointerId = null;
      root.classList.remove('is-done', 'is-blocked', 'is-pressed', 'is-dragging');
      label.textContent = labelInicial;
      definir(0, true);
    }
    root.__spReset = reativar;

    root.addEventListener('pointerdown', function (e) {
      if (confirmado || e.button === 1 || e.button === 2) return;
      if (e.target.closest('a, button:not(.solfie-swipe__knob)')) return;
      medir();
      arrastando = true;
      pointerId = e.pointerId;
      inicioX = e.clientX;
      /* começa de onde o círculo está — evita pulo quando o toque não é no centro */
      inicioP = p;
      root.classList.add('is-pressed');
      if (root.setPointerCapture) {
        try { root.setPointerCapture(e.pointerId); } catch (err) { /* ok */ }
      }
      e.preventDefault();
    });

    root.addEventListener('pointermove', function (e) {
      if (!arrastando || e.pointerId !== pointerId) return;
      var delta = e.clientX - inicioX;
      definir(inicioP + delta / max, false);
      if (Math.abs(delta) > 3) root.classList.add('is-dragging');
    });

    function soltar(e) {
      if (!arrastando) return;
      if (e && e.pointerId != null && pointerId != null && e.pointerId !== pointerId) return;
      var passou = p >= THRESHOLD;
      arrastando = false;
      pointerId = null;
      root.classList.remove('is-pressed', 'is-dragging');
      if (passou) confirmar();
      else { definir(p, true); window.setTimeout(function () { if (!confirmado) definir(0); }, 40); }
    }

    root.addEventListener('pointerup', soltar);
    root.addEventListener('pointercancel', soltar);
    root.addEventListener('lostpointercapture', function () { soltar(); });

    /* teclado */
    root.addEventListener('keydown', function (e) {
      if (confirmado) return;
      var passo = 0.2;
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { definir(p + passo, true); e.preventDefault(); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { definir(p - passo, true); e.preventDefault(); }
      else if (e.key === 'Home' || e.key === 'Escape') { definir(0, true); e.preventDefault(); }
      else if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        root.classList.add('is-done');
        definir(1, true);
        window.setTimeout(confirmar, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 380);
      }
    });

    root.addEventListener('focus', medir);
    window.addEventListener('resize', function () {
      if (confirmado) return;
      medir();
      definir(p, true);
    });

    /* o drawer abre depois do boot (largura 0 -> 390): remede quando mudar */
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (confirmado || arrastando) return;
        medir();
        definir(p, true);
      }).observe(root);
    }

    medir();
    definir(0, true);
  }

  function iniciar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-solfie-swipe]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  document.addEventListener('shopify:section:load', iniciar);
  /* o drawer e re-renderizado pelo tema (morph): tenta de novo quando o DOM muda */
  if (window.MutationObserver) {
    var pendente = null;
    new MutationObserver(function () {
      if (pendente) return;
      pendente = window.setTimeout(function () { pendente = null; iniciar(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function reativar(el) {
    if (el && typeof el.__spReset === 'function') el.__spReset();
  }

  window.SolfieSwipe = { init: init, iniciar: iniciar, reativar: reativar };
})();
